// Çevirmen Şeridi — bugünün hedef-etkisi olayları.

import type { TranslatorEvent } from "../types/api";
import CevirmenKart from "./CevirmenKart";

interface Props {
  events: TranslatorEvent[];
  /** Sinyal kartı tıklandığında çağrılır */
  onSignalClick?: (event: TranslatorEvent) => void;
  /** Değerlendirilmiş sinyal fund kodu set'i (örn. "TLY"). */
  evaluatedFunds?: Set<string>;
}

export default function CevirmenSerit({
  events,
  onSignalClick,
  evaluatedFunds,
}: Props) {
  return (
    <div className="grow min-w-0 flex flex-col self-stretch">
      <header className="flex items-center gap-2 mb-2 px-1">
        <span
          className="inline-flex items-center justify-center w-5 h-5 rounded bg-accent-500/15 text-accent-300"
          aria-hidden="true"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 12h12M12 6l6 6-6 6" />
          </svg>
        </span>
        <h2 className="text-[11px] uppercase tracking-wider text-ink-300 font-medium">
          Bugün hedefe etkisi
        </h2>
      </header>

      {/* Liste yüksekliği ebeveynin (`items-stretch` flex sırası) yüksekliğine
          bağlı; termometre ile aynı baseline'a oturur. min-h-0 → flex
          shrink'in overflow-y-auto'yu kilitlemesini engeller (flexbox quirk). */}
      <ol
        className="flex flex-col gap-2 overflow-y-auto no-scrollbar pr-1 grow min-h-0"
      >
        {events.length === 0 ? (
          <li className="text-[12px] text-ink-400 italic px-1 py-3">
            Henüz olay yok — sinyal motoru ve TÜFE güncellemesi geldiğinde dolar.
          </li>
        ) : (
          events.map((ev) => {
            const clickable =
              ev.kind === "sinyal" && !!onSignalClick && !!ev.fund;
            return (
              <li key={ev.id}>
                <CevirmenKart
                  event={ev}
                  onClick={clickable ? () => onSignalClick!(ev) : undefined}
                  evaluated={!!(ev.fund && evaluatedFunds?.has(ev.fund))}
                />
              </li>
            );
          })
        )}
      </ol>
    </div>
  );
}
